import React, { useState } from "react";
import { COLORS, IMAGES } from "@app/constants";
import { useToken } from "@app/hooks";
import { useMyProfile } from "../../../../hooks/user/myprofile";
import CIUtils from "../../../../../utils/ciutils";
import { HeaderProfieSection, HeaderProfieUid } from "../styles";
import styled from "styled-components";
import {useNavigate} from "react-router-dom";
import { t } from "i18next";
import { VITE_APP_API_MEDIA_URL } from "@/app/constants/APIKEYS";

const HeaderProfie = () => {
  const { mutate: mutateToken } = useToken();
  const { data: myinfo, mutate: mutateProfile } = useMyProfile();

  const navigate = useNavigate();

  return (
    <HeaderProfieSection>
      <ProfileRow>
        <UserImage  src={myinfo?.profileimage ? `${VITE_APP_API_MEDIA_URL}/${myinfo?.profileimage}` : IMAGES.avatar}/>

        <HeaderProfieUid>
          <UserName >{myinfo?.nickname}</UserName>

          <UserUID >
            UID : {CIUtils.padId(myinfo?.id)}
          </UserUID>
        </HeaderProfieUid>
      </ProfileRow>

      <SelectWrap>
      <SelectText onClick={() => navigate('/asset')}>{t('assets')}</SelectText>
      {/* <SelectText onClick={() => navigate('/orders')}>Orders</SelectText> */}
        <SelectText onClick={() => navigate('/settings?tab=1')}>{t('accountSecurity')}</SelectText>
        <SelectText onClick={() => navigate('/referral')}>{t('referralProgram')}</SelectText>
        <SelectText onClick={() => navigate('/settings?tab=2')}>{t('audit')}</SelectText>
        <SelectText onClick={() => navigate('/settings?tab=4')}>{t('settings')}</SelectText>
      </SelectWrap>


      {/*<AuthButtonLists title={"accountSecurity"} go={"/settings?tab=1"} />*/}

      {/*<AuthButtonLists title={"referralProgram"} go={"/referral"} />*/}

      {/*<AuthButtonLists title={"audit"} go={"/settings?tab=2"} />*/}

      {/* <AuthButtonLists
				title={'tradingViewAlerts'}
				go={'/settings?tab=4'}
			/> */}
      {/*<AuthButtonLists title={"settings"} go={"/settings?tab=3"} />*/}

      {/* <AuthButtonLists title={'myFeeRates'} go={'settings'} />
			<AuthButtonLists title={'myRewards'} go={'settings'} /> */}
      {/* <AuthButtonLists title={'subaccount'} go={'settings'} /> */}
      {/* <AuthButtonLists title={'api'} go={'/settings'} /> */}

      {/*<AuthButtonLists*/}
      {/*  title={"logout"}*/}
      {/*  action={() => {*/}
      {/*    mutate(null);*/}
      {/*    // setTimeout(() => window.location.reload(), 100)*/}
      {/*  }}*/}
      {/*  style={{*/}
      {/*    width: "50%",*/}
      {/*    marginTop: 15,*/}
      {/*    marginLeft: 130,*/}
      {/*    alignItems: "flex-end",*/}
      {/*  }}*/}
      {/*/>*/}
      <LogoutText onClick={() => navigate('/logout')}>{t('logout')}</LogoutText>
    </HeaderProfieSection>
  );
};

export default React.memo(HeaderProfie);


const ProfileRow = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    padding: 19px 16px;

    border-bottom: 1px solid ${({theme}) => theme.p2pBorder};
`

const UserImage = styled.img`
    width: 42px;
    height: 42px;
    margin-right: 10px;
    border-radius: 100%;
`

const UserName = styled.div`
  font-weight: 600;
    font-size: 15px;
    line-height: 18px;
    color: ${({theme}) => theme.text};
`

const UserUID = styled.div`
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: ${({theme}) => theme.text};
`

const SelectText = styled.div`
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    line-height: 16.71px;
    color: ${({theme}) => theme.text};
    padding: 10px 0;
    
    &:hover {
        color: #FF4C00;
    }
`

const SelectWrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 20px;
`

const LogoutText = styled.div`
  text-align: end;
    padding: 10px 20px 20px 20px;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    line-height: 16.71px;
    color: ${({theme}) => theme.inputPlaceholderText};
    
    &:hover {
        color: #FF4C00;
    }
`